import React from "react";
import parse, { domToReact } from 'html-react-parser';

/* TODO: fix cases where text may match across elements. i.e., "a ca" for "a <a>campaign</a>" */
function MarkMatchedText({ text, searchText }) {
  if (!searchText) return parse(text);

  const addHighlights = (string, searchText) => {
    const parts = string.split(new RegExp(`(${searchText})`, 'gi'));
    console.log(parts)
    return (
      <>
        {parts.map((part, index) => (
          part.toLowerCase() === searchText.toLowerCase() ? (
            // Wrap the matched part in <mark> tag
            <mark key={index}>{part}</mark>
          ) : (
            // Render the non-matched parts as is
            <span key={index}>{part}</span>
          )
        ))}
      </>
    );
  }

  const highlightText = (node) => {
    if ( ! node.type ) {
      return addHighlights(node, searchText);
    }
    else if (React.isValidElement(node)) {
      addHighlights(node.props.children, searchText);
      return React.cloneElement(
        node,
        {},
        addHighlights(node.props.children, searchText)
      );
    }
    return domToReact(node);
  };

  const parsedContent = parse(text, {
    replace: domNode => domNode
  });

  return <>{Array.isArray(parsedContent) ? parsedContent.map(highlightText) : highlightText(parsedContent)}</>;
}

export default MarkMatchedText;






/*import React
 from "react";
function MarkMatchedText({ text, searchText }) {
  // Split the text into an array of substrings based on the searchText
  if ( ! searchText ) return text;
  
  const parts = text.split(new RegExp(`(${searchText})`, 'gi'));

  return (
    <>
      {parts.map((part, index) => (
        part.toLowerCase() === searchText.toLowerCase() ? (
          // Wrap the matched part in <mark> tag
          <mark key={index}>{part}</mark>
        ) : (
          // Render the non-matched parts as is
          <span key={index}>{part}</span>
        )
      ))}
    </>
  );
};

export default MarkMatchedText;*/